import React from 'react';
import { useTranslation } from '@shared/core';
import { StyledBackgroundImage, StyledButtonContainer, StyledContainer, StyledOverlay, StyledTitle, styles } from './BrowseMoreBanner.styles';
import { ButtonV2 } from '@withjoy/joykit';

interface BrowseMoreBannerProps {
  categoryTitle: string;
  backgroundImageURL: string;
  onBrowseCategoryClick: () => void;
}

const BrowseMoreBanner: React.FC<BrowseMoreBannerProps> = ({ categoryTitle, backgroundImageURL, onBrowseCategoryClick }) => {
  const { t } = useTranslation('catalogRegistry');
  const { bannerText, browseButton } = t('browseCategoryBanner');

  return (
    <StyledContainer __css={styles.container} onClick={onBrowseCategoryClick}>
      <StyledBackgroundImage __css={styles.backgroundImage(backgroundImageURL)}>
        <StyledOverlay __css={styles.overlay}>
          <StyledTitle __css={styles.title} typographyVariant="display1" fontWeight={'semibold'}>
            {bannerText({ categoryTitle })}
          </StyledTitle>
          <StyledButtonContainer __css={styles.buttonContainer}>
            <ButtonV2
              color="white"
              borderColor="white"
              intent="neutral"
              variant="outline"
              _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.10)', borderColor: 'white', color: 'white' }}
              _active={{ backgroundColor: 'rgba(255, 255, 255, 0.20)', borderColor: 'white', color: 'white' }}
            >
              {browseButton()}
            </ButtonV2>
          </StyledButtonContainer>
        </StyledOverlay>
      </StyledBackgroundImage>
    </StyledContainer>
  );
};

export { BrowseMoreBanner };
